import { FormatListBulletedRounded, WidgetsRounded } from '@mui/icons-material'
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import React, { Dispatch, MouseEvent, SetStateAction } from 'react'

type ViewType = 'list' | 'grid'

interface ViewToggleButtonsProps {
  activeView: ViewType
  setActiveView: Dispatch<SetStateAction<ViewType>>
}

export const ListGridToggleButtons: React.FC<ViewToggleButtonsProps> = ({
  activeView,
  setActiveView,
}) => {
  const handleViewChange = (_event: MouseEvent<HTMLElement>, view: ViewType) => {
    setActiveView(view)
  }

  return (
    <Stack mt={2} width="100%" alignItems="flex-end">
      <ToggleButtonGroup
        exclusive
        size="small"
        color="primary"
        value={activeView}
        onChange={handleViewChange}
      >
        <ToggleButton value="list">
          <FormatListBulletedRounded />
        </ToggleButton>

        <ToggleButton value="grid">
          <WidgetsRounded />
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  )
}
